<template>
    <div class="corsetip-wrap">
        <div class="corsetip-tabs">
            <span
                class="tab-item"
                :class="activeTab == item.value ? 'tab-active' : ''"
                v-for="item in tabs"
                :key="item.value"
                @click="switchTab(item.value)"
            >{{item.label}}</span>
        </div>
        <div class="corsetip-list" v-loading="loading">
            <template v-if="list.length">
                <div v-for="(item, index) in list" :key="item.id">
                    <div class="time-sep" v-if="showTimeSep(index)">{{ formatTime(item.sendTime) }}</div>
                    <div class="msg-card" :class="item.readStatus == '0' ? 'unread' : ''">
                        <div class="msg-card-source">学习中心</div>
                        <div class="msg-card-type">{{ typeLabel(item.type) }}</div>
                        <div class="msg-card-content">{{ item.content }}</div>
                        <div class="msg-card-footer">
                            <el-button type="primary" size="small" @click="viewAction(item)">立即查看</el-button>
                        </div>
                    </div>
                </div>
            </template>
            <div class="empty-wrap" v-else>
                <el-empty description="暂无消息"></el-empty>
            </div>
        </div>
        <div class="corsetip-page flex" v-if="total > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="pageChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import {getMessageList, getMessageDetail} from "@/api/enterprise/index"


export default {
    name: 'corsetip',
    data() {
        return {
            businessInfo: {},
            loading: false,
            activeTab: '',
            tabs: [
                { label: '全部', value: '' },
                { label: '未读', value: '0' },
                { label: '已读', value: '1' },
            ],
            allList: [],
            list: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getList()
    },
    methods: {
        typeLabel(type) {
            const map = {
                11: '课程更新提醒', 12: '课程学习提醒', 13: '未学提醒',
                21: '在线考试提醒', 22: '在线考试结果通知',
                31: '仿真考核提醒', 32: '仿真考核结果通知',
            }
            return map[type] || '系统消息'
        },
        showTimeSep(index) {
            if (index === 0) return true
            const cur = this.list[index].sendTime
            const prev = this.list[index - 1].sendTime
            return cur && prev && cur.slice(0, 10) !== prev.slice(0, 10)
        },
        formatTime(sendTime) {
            if (!sendTime) return ''
            const d = new Date(sendTime.replace(' ', 'T'))
            if (isNaN(d)) return sendTime
            const y = d.getFullYear()
            const m = d.getMonth() + 1
            const day = d.getDate()
            const hh = String(d.getHours()).padStart(2, '0')
            const mm = String(d.getMinutes()).padStart(2, '0')
            return `${y}年${m}月${day}日 ${hh}:${mm}`
        },
        switchTab(val) {
            this.activeTab = val
            this.currentPage = 1
            this.getList()
        },
        pageChange(page) {
            this.currentPage = page
            this.updatePageList()
        },
        updatePageList() {
            const start = (this.currentPage - 1) * this.pageSize
            this.list = this.allList.slice(start, start + this.pageSize)
        },
        getList() {
            this.loading = true
            getMessageList({
                businessId: this.businessInfo.id,
                readStatus: this.activeTab,
            }).then(res => {
                if (res.code == 0) {
                    let data = []
                    if (Array.isArray(res.data)) {
                        data = res.data
                    } else {
                        data = res.data.records || res.data || []
                    }
                    this.allList = data
                    this.total = data.length
                    this.updatePageList()
                }
            }).catch(() => {}).finally(() => {
                this.loading = false
            })
        },
        viewAction(item) {
            getMessageDetail(item.id).then(res => {
                const data = res.code == 0 ? res.data : item
                const type = String(data.type || item.type)
                const linkId = data.linkId || item.linkId
                this.jumpByType(type, linkId)
            }).catch(() => {
                this.jumpByType(String(item.type), item.linkId)
            })
        },
        jumpByType(type, linkId) {
            if (['11', '12', '13'].includes(type)) {
                const newurl = this.$router.resolve({ name: 'HlrjenCourseDetail', query: { id: linkId } })
                window.open(newurl.href, '_blank')
            } else if (['21', '31'].includes(type)) {
                this.$router.push('/myExam/testingCenter?businessId=' + this.businessInfo.id + '&examId=' + linkId)
            } else {
                this.$router.push('/myExam/examRecords?businessId=' + this.businessInfo.id)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.corsetip-wrap {
    padding: 20px 0 40px;
    min-height: calc(100vh - 60px);
    background: #f0f2f5;
    .corsetip-tabs {
        text-align: center;
        margin-bottom: 20px;
        .tab-item {
            display: inline-block;
            padding: 6px 24px;
            margin: 0 4px;
            border-radius: 20px;
            font-size: 14px;
            color: #666;
            background: #fff;
            border: 1px solid #e6e6e6;
            cursor: pointer;
            transition: all 0.2s;
            &:hover { color: #409eff; border-color: #409eff; }
        }
        .tab-active {
            color: #fff;
            background: #409eff;
            border-color: #409eff;
        }
    }
    .corsetip-list {
        max-width: 600px;
        margin: 0 auto;
        padding: 0 16px;
        .time-sep {
            text-align: center;
            font-size: 13px;
            color: #999;
            margin: 20px 0 12px;
        }
        .msg-card {
            background: #fff;
            border-radius: 8px;
            padding: 20px 24px;
            margin-bottom: 12px;
            box-shadow: 0 1px 4px rgba(0,0,0,0.07);
            position: relative;
            &.unread::before {
                content: '';
                position: absolute;
                left: -6px;
                top: 50%;
                transform: translateY(-50%);
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #f56c6c;
            }
            .msg-card-source {
                font-size: 13px;
                color: #999;
                margin-bottom: 4px;
            }
            .msg-card-type {
                font-size: 13px;
                color: #999;
                margin-bottom: 10px;
            }
            .msg-card-content {
                font-size: 14px;
                color: #333;
                line-height: 1.6;
                margin-bottom: 16px;
            }
            .msg-card-footer {
                text-align: center;
            }
        }
    }
    .empty-wrap {
        padding: 80px 0;
    }
    .corsetip-page {
        justify-content: center;
        padding: 24px 0 0;
    }
}
</style>
